import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { Box } from '../Box';
import { Typography } from '../Typography';

import { StyledRadioInput } from './Radio.styled';
import type { RadioComponent, RadioProps } from './Radio.types';

export const Radio: RadioComponent = forwardRef(
  <C extends ElementType = 'input'>(
    {
      name,
      value,
      checked,
      disabled,
      label,
      sizeType = '2XS',
      styledComponents,
      ...props
    }: RadioProps<C>,
    ref: PolymorphicRef<C>,
  ) => {
    return (
      <Box
        alignItems='center'
        as='label'
        className='RadioWrapper'
        display='flex'
        gap={8}
        htmlFor={`${name}-${value}`}
        {...styledComponents?.root}
      >
        <StyledRadioInput
          checked={checked}
          className='styledRadioButton'
          disabled={disabled}
          id={`${name}-${value}`}
          name={name}
          ref={ref}
          sizeType={sizeType}
          type='radio'
          value={value}
          {...styledComponents?.input}
          {...props}
        />
        {label && (
          <Typography
            {...styledComponents?.label}
            color={disabled ? 'text.disabled' : 'text.primary'}
            fontType='body2.regular'
          >
            {label}
          </Typography>
        )}
      </Box>
    );
  },
);
